import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { AuthUser } from '@/types'

interface AppState {
  theme: 'light' | 'dark'
  sidebarCollapsed: boolean
  authenticated: boolean
  user: AuthUser | null
  toggleTheme: () => void
  toggleSidebar: () => void
  loginSuccess: (user: AuthUser) => void
  logout: () => void
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      theme: 'light',
      sidebarCollapsed: false,
      authenticated: false,
      user: null,
      toggleTheme: () =>
        set((state) => ({ theme: state.theme === 'light' ? 'dark' : 'light' })),
      toggleSidebar: () =>
        set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      loginSuccess: (user) => set({ authenticated: true, user }),
      logout: () => {
        localStorage.removeItem('senyao_token')
        set({ authenticated: false, user: null })
      },
    }),
    {
      name: 'senyao-app-storage',
      partialize: (state) => ({
        theme: state.theme,
        sidebarCollapsed: state.sidebarCollapsed,
        authenticated: state.authenticated,
        user: state.user,
      }),
    }
  )
)

export function isSuperAdmin(user: AuthUser | null): boolean {
  return !!user?.roles.includes('super_admin')
}
